module.exports = __webpack_public_path__ + "static/media/oval.aec813cd.svg";